import React, {useState} from 'react';
// import { logout } from '../api/auth';
import { logout } from '../api/auth.sso';
import images from '../images';
import useAuth from '../hooks/useAuth';
import LogoBlock from '../components/LogoBlock';
import {Link, useLocation, useParams} from "react-router-dom";
import { useNotifications } from '../context/NotificationsContext';

const Header = () => {
  const { logout: contextLogout } = useAuth();
  const location = useLocation();
  const { openNotifications } = useNotifications();
  
  // Получаем id из URL вручную (так как Header вне Routes)
  const parseUserIdFromPath = () => {
    const pathParts = location.pathname.split('/');
    // Путь может быть /advertisers/profile/6 или /advertisers/flows/6 или /advertisers/leads/6
    const idIndex = pathParts.indexOf('profile');
    if (idIndex === -1) {
      const flowsIndex = pathParts.indexOf('flows');
      const leadsIndex = pathParts.indexOf('leads');
      if (flowsIndex !== -1) return pathParts[flowsIndex + 1];
      if (leadsIndex !== -1) return pathParts[leadsIndex + 1];
    }
    return idIndex !== -1 ? pathParts[idIndex + 1] : null;
  };
  
  const selectedUserId = parseUserIdFromPath();

  const getActivePage = (pathname) => {
    return '/advertisers';
  };

  const getViewNotifications = (pathname) => {
    if (pathname.includes('/advertisers/profile') || pathname.includes('/advertisers/leads') || pathname.includes('/advertisers/flows')) {
      return true;
    } else {
      return false;
    }
  };

  const activePage = getActivePage(location.pathname);
  const viewNotifications = getViewNotifications(location.pathname);

  const handleRulesClick = () => {
    console.log('handleRulesClick');
    window.open('https://docs.google.com/document/d/1tarscKtoRJdB8ZndtuVDLQdgfOq8Qz4hEboO46dv_ng/edit?tab=t.0', '_blank', 'noopener,noreferrer');
  };

  const handleOpenNotificationsModal = () => {
    openNotifications(selectedUserId);
  };

  const handleLogout = async () => {
    try {
      await logout();
      contextLogout();
    } catch (error) {
      console.error('Ошибка при выходе:', error);
    }
  };

  console.log(location.pathname);

  console.log(location.pathname.includes('/advertisers/profile') && location.pathname.includes('/advertisers/leads') && location.pathname.includes('/advertisers/flows'));
  return (
    <header className="header">
      <div className="header-container">
        <LogoBlock />

        <nav className="navigation">
          <ul>
            <li>
              <Link
                  to="/advertisers"
                  className={activePage === '/advertisers' ? 'nav-link active' : 'nav-link'}
              >
                <img
                    src={activePage === '/advertisers' ? images.exportOutlineActive : images.exportOutline}
                    alt=""
                    className="nav-icon"
                />
                Рекламодатели
              </Link>
            </li>
          </ul>
        </nav>

        <div className="header-footer">
          {
            viewNotifications && (
                  <button className="footer-button" onClick={() => handleOpenNotificationsModal()}>
                    <img src={images.bellBold} alt="" className="footer-icon"/>
                    <span className="footer-text telegram">Уведомления</span>
                  </button>
              )
          }

          <button
              className="footer-button"
              onMouseDown={handleRulesClick}
          >
            <img src={images.question} alt="" className="footer-icon"/>
            <span className="footer-text rules">Правила пользования</span>
          </button>
          <button className="footer-button" onClick={handleLogout}>
            <img src={images.exitLinear} alt="" className="footer-icon"/>
            <span className="footer-text">Выход</span>
          </button>
        </div>
      </div>

    </header>
  );
};

export default Header;
